<template>
    <header
        class="bg-gray-tier-3 h-[49px] px-6 flex items-center justify-start w-full border-b border-keyline-primary print:hidden z-10 sticky top-[var(--app-header-height)]"
        :class="{
            'pl-4': useBackButton
        }"
        id="app-section-header"
    >
        <Link
            v-if="useBackButton"
            :href="backButtonUrl"
            class="mr-1.5 hover:bg-gray-tier-5 rounded-full"
        >
            <base-svg name="icon-chevron-left" />
        </Link>
        <h3 v-if="title" class="gap-1 flex items-center">
            <span>{{ $t(title) }}</span>
            <BaseSvg
                v-if="subTitle"
                name="chevron-right"
                class="w-5 h-5"
            />
            <span v-if="subTitle" class="font-medium flex-1">{{ subTitle }}</span>
        </h3>
        <div v-if="search"
            :class="{
                'items-end ml-auto': !title,
                'items-end': title
            }"
        >
            <SearchInput v-model="computedModel" />
            <slot name="buttons" />
        </div>
    </header>
</template>

<script setup>
import { SearchInput, BaseSvg } from "@/Components";
import { computed } from "vue";

const props = defineProps(["title", "search", "modelValue", "useBackButton", "backButtonUrl", "subTitle"]);
const emit = defineEmits(["update:modelValue"]);

let computedModel = computed({
    get() {
        return props.modelValue;
    },
    set(newValue) {
        emit("update:modelValue", newValue);
    },
});
</script>
